





































































































































































































































































































import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { RentalStatusEnum } from "@/lib/enum/rental-status.enum";
import { detailedDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRental } from "@/models/rental.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";
import MExpansion from "../utility/mmmint/MExpansion.vue";
import MIconButton from "../utility/mmmint/MIconButton.vue";
import RentalUpdateDialog from "./RentalUpdateDialog.vue";
import RentalReturnDialog from "./RentalReturnDialog.vue";

@Component({
  components: {
    MNoContent,
    MTextField,
    MSelect,
    InvoicePartySheet,
    SelectAssignees,
    MExpansion,
    RentalUpdateDialog,
    Debug,
    MIconButton,
    RentalReturnDialog
  },
  filters: {
    detailedDate
  }
})
export default class RentalSheet extends mixins(PermissionMixin) {
  @Prop({ required: true }) readonly rental!: IRental;

  showDocument = true;

  returnDialog = false;
  editDialog = false;

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get statusItems() {
    return Object.values(RentalStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RentalStatusEnum.${value}`)
    }));
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.canUpdateRental) return;
    const rental = this.rental;

    if (!rental) return;
    await rental.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.canUpdateRental) return;
    const rental = this.rental;
    if (!rental) return;
    await this.rental.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.canUpdateRental) return;
    const rental = this.rental;
    if (!rental) return;
    await rental.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }
}
